import React, { useState, useEffect, Fragment } from 'react';
import $ from 'jquery';
import { TableContent } from '../../Common/Table/tableContent';
import { PageHeader } from '../../../Common';
import services from '../services';

export function CollectionPointListing(props) {
    
    const contentRowNames = ["customerName"];

    const [collectionpoint, setCollectionPoint] = useState([]);

    useEffect(() => {
        getAllCollectionPoint()
    }, []);

    async function getAllCollectionPoint() {
        const collectionpoint = await services.getAllDetails()
        //   const formatedCustomers = formatNames(customers);
        destroyDataTable();
        setCollectionPoint(collectionpoint);
        createDataTable();
    }

    function formatNames(customers) {
        let formatedCustomers = customers.map(obj => ({ ...obj, customerName: obj.firstName + ' ' + obj.lastName }));

        return formatedCustomers;
    }

    function destroyDataTable() {
        $('#example').DataTable().destroy();
    }

    function createDataTable() {
        $('#example').DataTable();
    }

    function handleClick(e) {
        e.preventDefault();
    }

    function editHandler(event, id) {
        // const encryptedResult = CommonEncryptParam(id.toString());
        //  this.props.history.push("collectionpoint/addEdit");

    }
    function rendercollectionpointTable(collectionpointList) {
        // alert(JSON.stringify(collectionpointList))
        let tableContent = collectionpointList === undefined ? null : (
            collectionpointList.map((collectionpoint) => {
                // alert(JSON.stringify(collectionpoint))
                let activeStatus = collectionpoint.collectionPoint.isActive ? "Active" : "InActive";
                return (
                    <tr key={collectionpoint.collectionPoint.collectionPointID}>
                        <td>{collectionpoint.factoryName}</td>
                        <td>{collectionpoint.estateName}</td>
                        <td>{collectionpoint.collectionPoint.collectionpointName}</td>
                        <td>{activeStatus}</td>

                        <td>
                            <a title="Edit" onClick={(event) => editHandler(event, collectionpoint.collectionPoint.collectionPointID)}><i className="fa fa-pencil-square fa-2x fore-color-cyan icon-green"></i> </a>
                        </td>


                    </tr>
                );
            })
        );

        return (
            <div className="table-responsive row-top-gap">
                <table id="example" className="display dataTable no-footer">
                    <thead>
                        <tr>
                            <th>Factory Name</th>
                            <th>Estate Name</th>
                            <th>Collection Point Name</th>

                            <th>Status</th>
                            <th>Edit</th>
                        </tr>
                    </thead>
                    <tbody>
                        {tableContent}
                    </tbody>
                </table>
            </div>
        );

    }

    let contents = rendercollectionpointTable(collectionpoint);
    return (
        <Fragment>
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <PageHeader
                                    title="Collection Point"
                                    isButtonEnable={true}
                                    buttonText="Add Collection Point"
                                    path="collectionpoint/addEdit" />
                            </div>
                            <hr />
                            <div className="table-responsive row-top-gap">
                                {contents}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}